document.addEventListener('DOMContentLoaded', () => {
  const columns = document.querySelectorAll('.footer__sitemap-column');
  if (!columns.length) return;

  columns.forEach((col) => {
    const heading = col.querySelector('.footer__sitemap-category');
    if (!heading) return;

    heading.addEventListener('click', (e) => {
      if (window.innerWidth > 768) return;
      e.preventDefault();
      e.stopPropagation();

      const isOpen = col.classList.contains('is-open');
      columns.forEach((c) => c.classList.remove('is-open'));
      if (!isOpen) col.classList.add('is-open');
    });
  });
});
